<ng-template #stepTemplate>
  <li
    class="m-step-indicator__step tw-flex tw-flex-col tw-items-center"
    [class.-active]="active"
    [style.min-width]="customWidth"
  >
    <div class="m-step-indicator__node tw-self-center" [attr.test-id]="testId">
      @if (!iconIndicator) {

      {{ indicator }} } @else { <bosch-ui-icon [name]="iconIndicator"></bosch-ui-icon> }
    </div>
    <span class="m-step-indicator__label tw-self-center">
      @if (label) {
      {{ label }}
      }@else {
      <ng-content select="[step-label]"></ng-content>
      }
    </span>
    <span>
      <ng-content select="[step-content]"></ng-content>
    </span>
  </li>
</ng-template>
